import { StatisticsPageStore, STATISTICS_PAGE_STORE, FilterPeriods } from 'store'
import { StyleProps } from 'utilities'
import { SelectOption } from '../../../components/shared/Select'

export type StatisticsMainPageProps = StyleProps & {
  [STATISTICS_PAGE_STORE]?: StatisticsPageStore
}

export const statsPeriodOptions: SelectOption<FilterPeriods>[] = [FilterPeriods.PAST_WEEK,
  FilterPeriods.PAST_MONTH, FilterPeriods.PAST_3_MONTHS].map(period => ({
  value: period,
  label: period
}))
